<template>
  <svg
    width="22"
    height="30"
    viewBox="0 0 22 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M10.9636 0.884766V7.92454C10.9636 8.72471 11.2815 9.49211 11.8473 10.0579C12.4131 10.6237 13.1805 10.9416 13.9807 10.9416H21.0205V26.0268C21.0205 26.827 20.7026 27.5944 20.1368 28.1602C19.571 28.726 18.8036 29.0439 18.0034 29.0439H3.92388C3.1237 29.0439 2.35631 28.726 1.7905 28.1602C1.2247 27.5944 0.90683 26.827 0.90683 26.0268V3.90181C0.90683 3.10164 1.2247 2.33424 1.7905 1.76844C2.35631 1.20263 3.1237 0.884766 3.92388 0.884766H10.9636ZM12.975 1.38761V7.92454C12.975 8.19126 13.081 8.44706 13.2696 8.63566C13.4582 8.82426 13.714 8.93022 13.9807 8.93022H20.5176L12.975 1.38761Z"
      fill="#082655"
    />
  </svg>
</template>

<script>
export default {
  name: 'BlueDocIcon'
};
</script>

<style scoped>

</style>
